import React, { useEffect, useState } from 'react'
import { Card, CardContent } from '../../../../components/ui/Card'
import { components } from "react-select"
import { DataTableNew } from '../../../../components/table-components/data-table'
import { Checkbox } from '../../../../components/ui/checkbox'
import DataTableColumnHeader from '../../../../components/table-components/data-table-column-header'
import { useDispatch, useSelector } from 'react-redux'
import { fetchPrices } from '../../../../store/actions/admin/pricesAction'
import { useNavigate } from 'react-router-dom'
import { ycrAction } from '../../../../store/actions/admin/ycrAction'
import countriesAccept from '../../../../shared'

const PriceContent = () => {
    const dispatch = useDispatch();
    const { prices, metaData, countries, ycrData } = useSelector((state) => state);
    const navigate = useNavigate()
    const [pricesData, setPricesData] = useState([])
    const [activeSelect, setActiveSelect] = useState(null)
    const [formData, setFormData] = useState({
        countryIds: [],
        interestRateDataTypeIds: []
    })
    const [intrestRateType, setIntrestRateType] = useState(null)
    const [indexOfLastItem, setIndexOfLastItem] = useState(null)
    const [indexOfFirstItem, setIndexOfFirstItem] = useState(null)
    const [fetchData, setFetchData] = useState(null)
    const [currentPages, setCurrentPages] = useState(null)
    const [perPages, setPerPages] = useState(null)
    const [allTypes, setAllTypes] = useState([]);
    const [groupedDataCurve, setGroupedDataCurve] = useState({});

    const handleRowSelected = async (rows) => {

        setFetchData(rows?.id)
    };


    // const countriesAccept = [
    //     'India',
    //     'United Kingdom',
    //     'United States',
    //     'Japan',
    //     "Germany",
    //     'European Union',
    // ]

    useEffect(() => {
        formData?.countryIds?.length > 0 && dispatch(ycrAction({ countryIds: formData?.countryIds.filter((item) => item !== 'all') }, false))
    }, [formData?.countryIds])

    useEffect(() => {
        if (formData?.countryIds?.length >= 1 && formData?.interestRateDataTypeIds?.length >= 1) {
            const filterData = { page: currentPages, perPage: perPages, countryIds: formData?.countryIds.filter((item) => item !== 'all'), interestRateDataTypeIds: formData?.interestRateDataTypeIds.filter((item) => item !== 'all') }
            dispatch(fetchPrices(filterData))
        }
    }, [ formData?.interestRateDataTypeIds?.length, currentPages, perPages])



    const allCountries = countries && countries.length ? [{ label: 'All', value: "all" }, ...countries.sort((a, b) => a.countryName.localeCompare(b.countryName)).filter((item) => countriesAccept.includes(item.countryName)).map((item) => {
        return { label: item.countryName, value: item._id }
    })] : [];

    useEffect(() => {
        setAllTypes(() => {
            const data = ycrData?.records?.length > 0 && [{ label: "All", value: "all" }, ...ycrData?.records?.map((type) => {
                return {
                    label: type?.type,
                    value: type?._id
                }
            })]
            return data
        })
    }, [ycrData])

    useEffect(() => {
        if (allCountries?.length > 0) {
            const countryIds = allCountries?.map((country) => country?.value)
            setFormData({
                ...formData,
                countryIds
            })
        }
    }, [])

    useEffect(() => {

        if (allTypes?.length > 0) {
            const typeIds = allTypes?.map((type) => type?.value)
            setFormData({
                ...formData,
                interestRateDataTypeIds: typeIds
            })
        }
    }, [allTypes])






    useEffect(() => {
        setPricesData(prices?.records && prices?.records?.length > 0 && prices?.records)

    }, [prices])

    const onChange = (filter) => {
        setPerPages(filter?.perPage)
        setCurrentPages(filter?.page)
    }


    useEffect(() => {

        if (currentPages && metaData?.pageSize) {

            setIndexOfLastItem(currentPages * metaData.pageSize);
            setIndexOfFirstItem((currentPages * metaData.pageSize) - metaData.pageSize);
        }

    }, [currentPages, metaData])

    const navigatePage = (item) => {
        const slugName = `${item?.data?.country?.alpha2Code}-${item?.data?.slug}-${item?.data?.interestRateDataType?.type}`
        navigate('/data/prices/' + slugName?.trim()?.replace(/\s+/g, "-"), {
            state: {
                data: item
            }
        })
    }

    const data = formData?.countryIds?.length > 0 && formData?.interestRateDataTypeIds?.length > 0 && pricesData?.length > 0 ? pricesData?.map((price, index) => {
        return {
            id: price._id,
            data: price,
            index: indexOfFirstItem + index + 1,
            Country: price.country?.countryName ?? "-",
            value: price?.value ?? "-",
            asset: price.name ?? "-",
            Curves: price?.interestRateDataType?.type ?? "-",
            Tenor: price?.maturity ?? "-",
            slug:price?.slug
        }

    }) : []

    const columns = [
        {
            accessorKey: "index",
            header: ({ column }) => (
                <DataTableColumnHeader column={column} title="Id" />
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.index}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "Country",
            header: ({ column }) => (
                <DataTableColumnHeader column={column} title="Country" />
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.Country}</span>
            },
            enableSorting: true,
        },
    
        {
            accessorKey: "Curves",
            header: ({ column }) => (
                <DataTableColumnHeader column={column} title="Curve" />
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.Curves}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "Tenor",
            header: ({ column }) => (
                <DataTableColumnHeader column={column} title="Tenor" />
            ),
            cell: ({ row }) => {
                return <span className='flex items-center text-[#2487EE] hover:underline cursor-pointer' onClick={() => navigatePage(row?.original)}>{row?.original?.Tenor}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "value",
            header: ({ column }) => (
                <DataTableColumnHeader column={column} title="Rate" />
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.value ?? "-"}</span>
            },
            enableSorting: true,
        },
    ];



    const onCheckedCustomFieldBox = (props) => {
        const { data } = props;
        if (data.value === 'all') {
            if (formData.interestRateDataTypeIds?.length === allTypes?.length) {
                setFormData({ ...formData, interestRateDataTypeIds: [] });

            } else {
                setFormData({ ...formData, interestRateDataTypeIds: allTypes.map(option => option.value) });
            }
        } else {
            setFormData((prev) => {
                let newData;
                const alreadyExists = prev.interestRateDataTypeIds.some(item => item === data.value);
                if (alreadyExists) {
                    const alreadyExistsData = prev.interestRateDataTypeIds.filter(item => item !== data.value);
                    newData = alreadyExistsData
                } else {
                    newData = allTypes?.value !== null ? [...prev.interestRateDataTypeIds, data?.value] : [data?.value];
                }
                return { ...prev, interestRateDataTypeIds: newData?.filter((aed) => aed !== "all") }
            })
        }
    };


    const onCheckedCustomFieldBox2 = (props) => {
        const { data } = props;
        if (data.value === 'all') {
            if (formData.countryIds?.length === allCountries?.length) {
                setFormData({ ...formData, countryIds: [] });

            } else {
                setFormData({ ...formData, countryIds: allCountries.map(option => option.value) });
            }
        } else {

            setFormData((prev) => {
                let newData;

                const alreadyExists = prev.countryIds.some(item => item === data.value);

                if (alreadyExists) {
                    const alreadyExistsData = prev.countryIds.filter(item => item !== data.value);
                    newData = alreadyExistsData
                } else {
                    newData = allCountries?.value !== null ? [...prev.countryIds, data?.value] : [data?.value];
                }

                return { ...prev, countryIds: newData?.filter((aed) => aed !== "all") }
            })
        }
    };


    const OptionCustomField = ({ children, ...props }) => {
        const { onCheckedCustomFieldBox } = props.selectProps;
        const checkedCondition = props?.data?.value === "all" && !formData?.interestRateDataTypeIds?.includes("all") && allTypes?.length - 1 === formData.interestRateDataTypeIds?.length ? true : formData.interestRateDataTypeIds?.includes(props.data.value)

        return (
            <components.Control {...props}>
                <div className="flex p-2 align-middle justify-start items-center text-sm w-full" onClick={() => onCheckedCustomFieldBox(props)}>
                    <span className="me-2">
                        <Checkbox
                            checked={checkedCondition}
                            aria-label="Select row"
                            // rounded-[4px]
                            className="translate-y-[2px] rounded-[4px] border-black " />
                    </span>
                    {children}
                </div>
            </components.Control>
        );
    };
    const OptionCustomField2 = ({ children, ...props }) => {

        const { onCheckedCustomFieldBox } = props.selectProps;

        //props?.data?.value === "all" && !checkedData?.includes("all") && assetOptions?.length - 1 === checkedData?.length ? true :
        const checkedCondition = props?.data?.value === "all" && !formData?.countryIds?.includes("all") && allCountries?.length - 1 === formData?.countryIds?.length ? true : formData?.countryIds?.includes(props.data.value)

        return (
            <components.Control {...props}>
                <div className="flex p-2 align-middle justify-start items-center text-sm w-full" onClick={() => onCheckedCustomFieldBox(props)}>
                    <span className="me-2">
                        <Checkbox
                            checked={checkedCondition}
                            aria-label="Select row"
                            // rounded-[4px]
                            className="translate-y-[2px] rounded-[4px] border-black " />
                    </span>
                    {children}
                </div>
            </components.Control>
        );
    };

    const handleSelectChange = (e) => {
        const parseValue = JSON.parse(e)
        setActiveSelect(parseValue)
    }

    const handleSelectChange2 = (e) => {
        const parseValue = JSON.parse(e)
        setIntrestRateType(parseValue)
    }

    const showNamesOfCountries = () => {
        let names = ""
        allCountries?.length > 0 && allCountries?.map((country) => {
            if (formData?.countryIds?.includes(country?.value)) {
                names += country?.label + ', '
            }
        })
        return names
    }
    const showNamesOfTypes = () => {
        let types = ""
        allTypes?.length > 0 && allTypes?.map((type) => {
            if (formData?.interestRateDataTypeIds?.includes(type?.value)) {
                types += type?.label + ', '
            }
        })
        return types
    }

    useEffect(() => {

        const groupedData2 = {};
        if (ycrData?.records?.length > 0) {
            groupedData2.all = [{ label: "All", value: "all" }]; // Add "all" option

            for (const record of ycrData?.records) {
                const countryName = record.country?.countryName || "Unknown"; // Check and set default for missing countryName
                groupedData2[countryName] = groupedData2[countryName] || []; // Initialize empty array if not already present
                groupedData2[countryName]?.push({ label: record?.type, value: record._id }); // Push record data
            }
        }

        setGroupedDataCurve(groupedData2)
    }, [ycrData?.records]);

    const transformedDataCurve = Object.entries(groupedDataCurve).map(([countryName, countryData]) => ({
        label: countryName,
        options: countryData.map(item => ({
            label: item.label,
            value: item?.value,
        })),
    }));

    // show all and other labels of group 

    const formatGroupLabel = (group) => {
        return (
            <div className='text-[12px] !p-0 text-gray-600 font-bold tracking-widest'>
                {group?.label}
            </div>
        )
    };


    const selectOptions = [
        {
            name: "All",
            text: "Country :",
            onChange: (e) => handleSelectChange(e),
            components: OptionCustomField2,
            isDisabled: false,
            className: "",
            placeholder: formData?.countryIds?.length > 0 ? showNamesOfCountries() : "Select country :",
            options: allCountries,
            onCheckedCustomFieldBox: onCheckedCustomFieldBox2,
        },
        {
            name: "All ",
            text: "Curves :",
            onChange: (e) => handleSelectChange2(e),
            components: OptionCustomField,
            isFormatGroupLabel: true,
            formatGroupLabel,
            isDisabled: !formData?.countryIds?.length,
            className: "",
            placeholder: formData?.interestRateDataTypeIds?.length > 0 ? showNamesOfTypes() : "Select Types :",
            options: transformedDataCurve,
            onCheckedCustomFieldBox,
        }
    ]



    return (
        <div className='p-5'>
            <Card className="bg-white p-4">
                <CardContent className="p-2">
                    <DataTableNew columns={columns} data={data} isLeftSelect={true} leftSelectOptions={selectOptions} onChange={onChange} hidePagination={data.length === 0} />
                </CardContent>
            </Card>
        </div>
    )
}


export default PriceContent
